module.exports = __webpack_public_path__ + "img/23_1908_ap.87784fbe.jpg";